import React, { useEffect } from "react";
import { useHistory } from 'react-router-dom';
// Style
import "./LevelComplete.scss";

import Polygon from "../../../assets/images/home/Polygon.svg";
import LevelCompleted from "../../../assets/images/home/level-complete.svg";
import Button from "../../../assets/images/home/Button.svg";
import proceed from "../../../assets/images/home/proceed.svg";

// ORDER:
// Core(dos) Pesca(nueve) Hangman(ocho) Emit(Seis) Center(diez) Compass(tres) Vicinus(cinco) Charge(cuatro) Edges(siete)

const LevelComplete = (props) => {
  const history = useHistory();
  const nextLevel = () => {
    switch (props.levelNum) {
      case "home":
        history.push("/level-dos");
        break;
      case 1:
        history.push("/level-nueve");
        break;
      case 2:
        history.push("/level-ocho");
        break;
      case 3:
        history.push("/level-seis");
        break;
      case 4:
        history.push("/level-diez");
        break;
      case 5:
        history.push("/level-tres");
        break;
      case 6:
        history.push("/level-cinco");
        break;
      case 7:
        history.push("/level-cuatro");
        break;
      case 8:
        history.push("/level-siete");
        break;
      // case 8:
      //   history.push("/level-nueve";
      //   break;
      // case 9:
      //   history.push("/level-diez";
      //   break;
      case 9:
        history.push("/game-complete");
        break;
      default:
        history.push("/home");
        break;
    }
  };

  useEffect(() => {
    let levelsDone = Number(localStorage.getItem("levelsDone"))
    localStorage.setItem("levelsDone", levelsDone + 1);
  }, []);

  return (
    <div className="component-level-complete">
      <div className="complete-modal">
        <div className="levels">
          <img className="star" src={LevelCompleted} alt={"star"} />{" "}
          <h1>{props.levelNum}</h1>
        </div>
        <div className="heading">Awesome !</div>
        <div className="subheading">You can proceed to the next round</div>
        <div className="button-div">
          <div className="top-btn" onClick={() => nextLevel()}>
            START LEVEL {props.levelNum + 1}{" "}
            <img className="proceed" src={proceed} alt={"star"} />
          </div>
          <div className="bottom-btn">
            START LEVEL {props.levelNum + 1}{" "}
            <img className="proceed" src={proceed} alt={"star"} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LevelComplete;
